export function SET_PREHOSPITAL_CARES(state, prehospitalCares) {
  state.prehospitalCares = prehospitalCares;
}

export function SET_PREHOSPITAL_CARE(state, prehospitalCare) {
  state.prehospitalCare = prehospitalCare;
}
